// extracted by mini-css-extract-plugin
export default {"mainContainer":"Datasets_mainContainer__JjeNf","contentArea":"Datasets_contentArea__IlhOL","contentCard":"Datasets_contentCard__cUHvs"};